"use strict";

require("init");
require("commonSite");